const types = {
  // LISTAR
  LIST_SERVICOS_REQUEST: "@servico/LIST_REQUEST",
  LIST_SERVICOS_SUCCESS: "@servico/LIST_SUCCESS",
  LIST_SERVICOS_FAILURE: "@servico/LIST_FAILURE",

  // CRIAR
  CREATE_SERVICO_REQUEST: "@servico/CREATE_REQUEST",
  CREATE_SERVICO_SUCCESS: "@servico/CREATE_SUCCESS",
  CREATE_SERVICO_FAILURE: "@servico/CREATE_FAILURE",

  // ATUALIZAR
  UPDATE_SERVICO_REQUEST: "@servico/UPDATE_REQUEST",
  UPDATE_SERVICO_SUCCESS: "@servico/UPDATE_SUCCESS",
  UPDATE_SERVICO_FAILURE: "@servico/UPDATE_FAILURE",

  // REMOVER
  DELETE_SERVICO_REQUEST: "@servico/DELETE_REQUEST",
  DELETE_SERVICO_SUCCESS: "@servico/DELETE_SUCCESS",
  DELETE_SERVICO_FAILURE: "@servico/DELETE_FAILURE",

  // FORM
  UPDATE_FORM: "@servico/UPDATE_FORM",
  RESET_FORM: "@servico/RESET_FORM",
};

export default types;
